export const NUMBER = {
  LOTTO_NUMBER_LENGTH: 6,
  LOTTO_MIN_NUMBER: 1,
  LOTTO_MAX_NUMBER: 45,
  LOTTO_PRICE: 1000,
  LOTTO_MAX_PRICE: 100000,
};
